"use client";
import { Animated } from "../animated";
import { Banner } from "./banner";
import { TheChallengeSolution } from "./the-challenge-solution";
import { CTA } from "./cta";
import { RealWorldSolutionsSection } from "../nsw-water-compliance/real-world-solutions";
import { SectionSeparator } from "../shared";
import { HowItWorks } from "./how-it-works";

export default function PlanrPlatformPage() {
  return (
    <Animated>
      <Banner />
      <TheChallengeSolution />
      <SectionSeparator
        imageUrl="/images/planr.webp"
        dataSpeed="0.05"
        overlayClassName="from-black/10 to-black/40"
      />
      <HowItWorks />
      <SectionSeparator
        imageUrl="/images/planr-environmental-accounts.webp"
        overlayClassName="from-black/5 to-black/10"
        dataSpeed="0.2"
      />
      <RealWorldSolutionsSection />
      <CTA />
    </Animated>
  );
}
